import styled, {ComponentSelector} from '@emotion/styled';

import {StyledTag} from '../Tag/styles';

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${StyledTag as ComponentSelector} {
    margin-right: var(--gutter-little);
    margin-top: var(--gutter-little);
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  button {
    font-size: var(--font-size-tiny);
  }
`;

export const StyledTagsGroup = styled.div`
  margin-bottom: var(--gutter-little);
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-thin);
  color: var(--color-core-primary);
`;
